<template>
  <section class="columns small-12">
    <aside class="margin_section">
      <div class="report-bar">
        <woot-loading-state
          v-if="isLoading"
          :message="$t('REPORT.LOADING_CHART')"
        />
        <div v-else class="chart-containerX">
          <!-- <woot-bar
            :collection="collection"
            :stacked="true"
          /> -->
          <BarChartApex
            v-if="reports"
            :series="graphData.dataList"
            :categories="graphData.barNames"
            :title="{text:`${$t('COUPON.REPORTS.TITLE')} ${sortBy.label}`}"
          />
          <span v-else class="empty-state">
            {{ $t('REPORT.NO_ENOUGH_DATA') }}
          </span>
        </div>
      </div>


    </aside>

  </section>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import BarChartApex from '../../../../../../dashboard/components/widgets/chart/BarChartApex.vue'

export default {
  components:{
    VeTable,
    Spinner,
    BarChartApex,
  },
  props:{
    reports:{
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: Object,
      default: {},
    },

  },
  data(){
    return {
    }
  },
  computed:{
    graphData(){
      // const barNames = ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2', '2012 Q3', '2012 Q4'];
      // const dataList = [
      //   { name: 'Redeem', data: [44, 55, 41, 67, 22, 43, 21, 49] },
      //   { name: 'Not redeem', data: [13, 23, 20, 8, 13, 27, 33, 12] },
      //   // { name: 'PRODUCT C', data: [11, 17, 15, 15, 21, 14, 15, 13] }
      // ]
      // return {
      //   barNames,
      //   dataList
      // }
      console.log(this.reports,"Reports");

      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const barNames = days.map(day => day.charAt(0).toUpperCase() + day.slice(1)); // Capitalized

        const redeemData = [];
        const notRedeemData = [];

        console.log({sortBy:this.sortBy});
        let dataList = [
          { name: 'Redeem', data: [] },
          { name: 'Not redeem', data: [] }
        ]

         if (this.sortBy.sortBy === 'value') {
          // Only show redeem data
          days.forEach(day => {
            redeemData.push(this.reports[day]);
          });
          const dataList = [
            { name: 'Redeem', data: redeemData }
          ];
          return { barNames, dataList };
        }

        days.forEach(day => {
          redeemData.push(this.reports[day].redeem);
          notRedeemData.push(this.reports[day]['not-redeem']);
        });
        dataList = [
          { name: 'Redeem', data: redeemData },
          { name: 'Not redeem', data: notRedeemData }
        ];

        return { barNames, dataList }
    },

    // end of computed
  },

  methods:{

    // methods end
  },
}
</script>




<style lang="scss" scoped>
// table styles START
@import '~dashboard/assets/scss/mixins';

.orders-table-wrap {
  flex: 1 1;
  height: 100%;
  overflow: hidden;
}

.orders-table-wrap::v-deep {
  .ve-table {
    padding-bottom: var(--space-large);

    .ve-table-container{
      overflow: visible;
    }
  }


  .ve-table-header-th {
    padding: var(--space-small) var(--space-two) !important;
    background-color: var(--w-500) !important;
    color: var(--white) !important;
  }

  .ve-table-body-td {
    padding: var(--space-small) var(--space-two) !important;
  }

  .ve-table-header-th {
    font-size: var(--font-size-mini) !important;
  }
  .ve-table-sort {
    top: -4px;
  }
  .status_wrapper select{
    padding-left: 8px;
  }
}

.orders--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}
.loadMore_btn button{
  display: block;
  margin: auto;
}
// table styles END
.margin_section{
  margin-top: var(--space-large);
}
</style>

